'use client'

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import {
  ArrowTopRightOnSquareIcon,
  ChevronDownIcon,
} from '@heroicons/react/20/solid'
import type { MurphysLink } from './buildMurphysLinks'

export function MurphysLinks({ links }: { links: MurphysLink[] }) {
  if (links.length === 0) {
    return null
  }

  if (links.length === 1) {
    return (
      <a
        className="inline-flex items-center gap-1 border-b border-transparent hover:border-white/80 transition-colors"
        href={links[0].href}
        target="_blank"
        rel="noopener noreferrer"
      >
        Murphy’s
        <ArrowTopRightOnSquareIcon className="size-3.5" aria-hidden="true" />
      </a>
    )
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      <MenuButton className="inline-flex items-center gap-0.5 border-b border-transparent hover:border-white/80 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80">
        Murphy’s
        <ChevronDownIcon className="size-4" aria-hidden="true" />
      </MenuButton>
      <MenuItems
        anchor="bottom end"
        className="z-50 mt-1 max-h-[min(24rem,calc(100vh-4rem))] min-w-56 overflow-y-auto overscroll-contain rounded-md bg-white py-1 text-sm text-gray-800 shadow-lg ring-1 ring-black/10 focus:outline-none"
      >
        {links.map(link => (
          <MenuItem key={link.productId}>
            {({ focus }) => (
              <a
                className={`flex items-center justify-between gap-4 px-3 py-2 ${
                  focus ? 'bg-gray-100 text-gray-950' : ''
                }`}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>{link.label}</span>
                <span className="flex shrink-0 items-center gap-1 text-xs text-gray-500">
                  {link.productId}
                  <ArrowTopRightOnSquareIcon
                    className="size-3.5"
                    aria-hidden="true"
                  />
                </span>
              </a>
            )}
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  )
}
